export default "__VITE_ASSET__ZuHVu1vx__"